import React from "react";

import Button from "./ui/Button";
import Flex from "./ui/Flex";
import { sendAnalytics } from "../helper";

const TypeSelector = ({ type, set, optionalPanels }) => {
  const {
    book_a_room_enabled: bookARoomEnabled,
    book_a_room_label: bookARoomLabel,
    general_enabled: generalEnabled,
    general_label: generalLabel,
  } = optionalPanels;

  const handleTypeChange = ({ value, label }) => {
    if (type === value) return;

    sendAnalytics({
      hitType: "event",
      eventAction: "Navigate",
      eventLabel: `Panel - ${label}`,
    });
    set(value);
  };

  return (
    <Flex>
      <Button
        onClick={() => {
          handleTypeChange({ value: "book-a-table", label: "Book a Table" });
        }}
        active={type === "book-a-table"}
      >
        Book a Table
      </Button>
      {bookARoomEnabled && (
        <Button
          onClick={() => {
            handleTypeChange({
              value: "book-a-room",
              label: bookARoomLabel || "Book a Room",
            });
          }}
          active={type === "book-a-room"}
        >
          {bookARoomLabel || "Book a Room"}
        </Button>
      )}
      {generalEnabled && (
        <Button
          onClick={() => {
            handleTypeChange({
              value: "general",
              label: generalLabel || "Call Us",
            });
          }}
          active={type === "general"}
        >
          {generalLabel || "Call Us"}
        </Button>
      )}
    </Flex>
  );
};

export default TypeSelector;
